import React from 'react'
import styled from 'styled-components'

import { Container } from '../global'

const Header = () => {
  return (
    <HeaderWrapper id="top">
      <MainContainer>
        <Flex>
          <StyledDivLeft>
            <h4>Let's learn about Residential Schools </h4>
            Learning about this piece of Canadian History is important for the
            reconciliation and healing of our Indigenous population
          </StyledDivLeft>
        </Flex>
      </MainContainer>
      <SecondaryContainer>
        <Flex>
          <div />
          <StyledDivRight>
            <h4>What we learned before</h4>
            Many students were introduced to this topic earlier in their life.
            There are also people who never had Residential Schools in their
            curriculum. The point is, many information we learned could have
            been forgotten. This is a resource to help fill the gaps
          </StyledDivRight>
        </Flex>
      </SecondaryContainer>
      <SecondaryContainer>
        <Flex>
          <StyledDivLeft>
            <h4>Refilling the gaps</h4>
            This project features bite-sized pieces of the history of
            residential schools. Track your progress and do quizzes to solidify
            what you learned!
          </StyledDivLeft>
        </Flex>
      </SecondaryContainer>
    </HeaderWrapper>
  )
}

export default Header

const HeaderWrapper = styled.header`
  background-color: ${props => props.theme.color.white};
  position: relative;
  height: 110vh;
`

const MainContainer = styled(Container)`
  padding: 130px 0 80px 0;
  @media (max-width: ${props => props.theme.screen.xs}) {
    padding: 130px 20px 100px 20px;
  }
`

const SecondaryContainer = styled(Container)`
  padding: 0px 0 100px 0;
  @media (max-width: ${props => props.theme.screen.xs}) {
    padding: 0px 20px 100px 20px;
  }
`

const Flex = styled.div`
  display: grid;
  justify-content: space-between;
  align-content: center;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    grid-gap: 30px;
  }
`

const StyledDivRight = styled.div`
  text-align: right;
  font-size: 17px;
  line-height: 40px;
`

const StyledDivLeft = styled.div`
  text-align: left;
  font-size: 17px;
  line-height: 40px;
`
